import { useSelector } from 'react-redux';

export const getFilteredData = state => state.users.filteredData;
export const useGetFilteredData = () => useSelector(getFilteredData);